import React, { useState, useEffect } from "react";
import {
  networkingSeries,
  fetchNetworkingStagesStatus
} from "./SalientComponents.js";
import moment from "moment";

const Divider = () => {
  return (
    <div className="divider-wrap" data-alignment="default">
      <div style={{ height: "30px" }} className="divider" />
    </div>
  );
};

const Tab = props => {
  return (
    <div
      id={"tab-" + props.stage.name}
      data-tab-icon={props.stage.icon}
      className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
    >
      <div
        data-midnight=""
        data-column-margin="default"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-content-top standard_section    "
        style={{ paddingTop: "0px", paddingBottom: "0px" }}
      >
        <div className="row-bg-wrap">
          <div className="row-bg   " />
        </div>
        <div className="col span_12  left">
          <div
            className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column padding-3-percent"
            data-t-w-inherits="default"
            data-shadow="none"
            data-border-radius="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="left-right"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <h3>{props.stage.name}</h3>
                    <h5>
                      <span style={{ color: "#05bff7" }}>
                        Step {props.stepNumber} of {props.series.name}
                      </span>
                    </h5>
                  </div>
                </div>

                <div
                  className="nectar-cta "
                  data-color="default"
                  data-using-bg="false"
                  data-style="see-through"
                  data-display="inline"
                  data-alignment="center"
                  data-text-color="custom"
                >
                  <h6 style={{ color: "#1e83ec" }}>
                    <span className="text"> </span>
                    <span className="link_wrap">
                      <a className="link_text" href="/contact/">
                        View Contacts in {props.stage.name}
                        <span className="arrow" />
                      </a>
                    </span>
                  </h6>
                </div>
                <Divider />
                <div className="wpb_text_column wpb_content_element ">
                  <div
                    className="wpb_wrapper"
                    dangerouslySetInnerHTML={{
                      __html: props.stage.description
                    }}
                  />
                </div>

                <Divider />
                <div className="wpb_text_column wpb_content_element  vc_custom_1583787598620">
                  <div className="wpb_wrapper">
                    <h4>{props.stage.name + " Resources"}</h4>
                  </div>
                </div>

                <div
                  className="nectar-fancy-ul"
                  data-list-icon="icon-salient-thin-line"
                  data-animation="true"
                  data-animation-delay="0"
                  data-color="extra-color-3"
                  data-spacing="default"
                  data-alignment="left"
                >
                  {props.stage.resources != null &&
                  props.stage.resources.length > 0 ? (
                    <ul>
                      {props.stage.resources.map(r => (
                        <li key={r.id}>
                          <a href={r.href}>{r.description}</a>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </div>
                <div
                  className="nectar-cta "
                  data-color="default"
                  data-using-bg="false"
                  data-style="see-through"
                  data-display="inline"
                  data-alignment="center"
                  data-text-color="custom"
                >
                  <h6 style={{ color: "#1e83ec" }}>
                    <span className="text"> </span>
                    <span className="link_wrap">
                      <a
                        className="link_text"
                        href="/prism-networking-resources/"
                      >
                        More Networking Resources
                        <span className="arrow" />
                      </a>
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const NetworkingPage = props => {
  const series = networkingSeries[0];
  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    if(props.wordpressId != null && props.nonce != null) {
      fetchNetworkingStagesStatus({
        wordpressId: props.wordpressId,
        callback: setStatuses,
        nonce: props.nonce
      });
    }
  }, [props.wordpressId,props.nonce]);

  return (
    <div>
      <div
        id="stages"
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="4%"
        data-bottom-percent="7%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{
          paddingTop: "calc(100vw * 0.04)",
          paddingBottom: "calc(100vw * 0.07)"
        }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-12 wpb_column column_container vc_column_container col has-animation padding-3-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="right"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation="fade-in-from-bottom"
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div
                  id="fws_5e7be9b44c9b0"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: 0, paddingBottom: "1%" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <h2 style={{ textAlign: "center" }}>
                                {series.name}
                              </h2>
                            </div>
                          </div>

                          <h5
                            style={{ color: "#999999", textAlign: "center" }}
                            className="vc_custom_heading vc_custom_1583932008635"
                          >
                            {series.subHeadingOne}
                          </h5>
                          <Divider />
                          <h3
                            style={{ color: "#05bff7", textAlign: "center" }}
                            className="vc_custom_heading vc_custom_1583931734362"
                          >
                            {series.subHeadingTwo}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="fws_5e7be9b44d817"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column padding-5-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="left-right"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <h5>
                                <span style={{ color: "#999999" }}>
                                  {series.stages != null &&
                                    series.stages.length > 0 &&
                                    series.stages.map(s => {
                                      return s.name + ". ";
                                    })}
                                </span>
                              </h5>
                              <h3>How It Works</h3>
                            </div>
                          </div>

                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-salient-thin-line"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-3"
                            data-spacing="default"
                            data-alignment="left"
                            dangerouslySetInnerHTML={{
                              __html: series.description
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_content_element" data-interval="0">
                  <div
                    className="wpb_wrapper tabbed clearfix"
                    data-style="minimal_flexible"
                    data-spacing=""
                    data-icon-size="24"
                    data-full-width-line=""
                    data-color-scheme="extra-color-gradient-2"
                    data-alignment="left"
                  >
                    <ul className="wpb_tabs_nav ui-tabs-nav clearfix">
                      <li>
                        <a href="#tab-1585161544291-9">
                          <span>BUILD</span>
                        </a>
                      </li>
                      <li>
                        <a href="#tab-1585161544572-3">
                          <span>DISCOVER</span>
                        </a>
                      </li>
                      <li>
                        <a href="#tab-1585161544817-5">
                          <span>CONNECT</span>
                        </a>
                      </li>
                      <li>
                        <a href="#tab-1585161545044-2">
                          <span>ASSESS</span>
                        </a>
                      </li>
                      <li>
                        <a href="#tab-1585161545270-8">
                          <span>ENGAGE</span>
                        </a>
                      </li>
                      <li>
                        <a href="#tab-1585161545459-5">
                          <span>MAINTAIN</span>
                        </a>
                      </li>
                    </ul>

                    {series.stages != null && series.stages.length > 0
                      ? series.stages.map((s, i) => (
                          <Tab
                            key={s.id}
                            stage={s}
                            series={series}
                            stepNumber={i + 1}
                          />
                        ))
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="results"
        data-column-margin="default"
        data-midnight="dark"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{ paddingTop: "0px", paddingBottom: "0px" }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-12 wpb_column column_container vc_column_container col centered-text padding-3-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <h2 style={{ textAlign: "center" }}>Networking Results</h2>
                  </div>
                </div>

                <h5
                  style={{ color: "#a3a3a3", textAlign: "center" }}
                  className="vc_custom_heading vc_custom_1583931955654"
                >
                  Track Your Weekly Progress In The PRISM Process
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="results"
        data-column-margin="default"
        data-midnight="dark"
        data-bottom-percent="5%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{ paddingTop: "0px", paddingBottom: "calc(100vw * 0.05)" }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-6 wpb_column column_container vc_column_container col padding-1-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div className="wpb_text_column wpb_content_element  vc_custom_1584811135971">
                  <div className="wpb_wrapper">
                    <h3>Your Progress In The PRISM Process</h3>
                    <p>
                      <i className="icon-tiny fa fa-arrow-left accent-color" />
                      {moment().format("dddd, MMMM Do YYYY")}
                      <i className="icon-tiny fa fa-arrow-right accent-color" />
                    </p>
                  </div>
                </div>

                <div className="nectar-progress-bar">
                  <p>BUILD // Goal: 10</p>
                  <div className="bar-wrap">
                    <span
                      className="extra-color-gradient-2"
                      data-width={
                        statuses.BuildComplete != null
                          ? statuses.BuildComplete
                          : 0
                      }
                    >
                      <strong>
                        <i>
                          {statuses.BuildComplete != null
                            ? statuses.BuildComplete
                            : 0}
                        </i>
                        %
                      </strong>
                    </span>
                  </div>
                </div>
                <div className="nectar-progress-bar">
                  <p>DISCOVER // Goal: 10</p>
                  <div className="bar-wrap">
                    <span
                      className="extra-color-gradient-2"
                      data-width={
                        statuses.DiscoverComplete != null
                          ? statuses.DiscoverComplete
                          : 0
                      }
                    >
                      <strong>
                        <i>
                          {statuses.DiscoverComplete != null
                            ? statuses.DiscoverComplete
                            : 0}
                        </i>
                        %
                      </strong>
                    </span>
                  </div>
                </div>
                <div className="nectar-progress-bar">
                  <p>CONNECT // Goal: 10</p>
                  <div className="bar-wrap">
                    <span
                      className="extra-color-gradient-2"
                      data-width={
                        statuses.ConnectComplete != null
                          ? statuses.ConnectComplete
                          : 0
                      }
                    >
                      <strong>
                        <i>
                          {statuses.ConnectComplete != null
                            ? statuses.ConnectComplete
                            : 0}
                        </i>
                        %
                      </strong>
                    </span>
                  </div>
                </div>
                <div className="nectar-progress-bar">
                  <p>ASSESS // Goal: 10</p>
                  <div className="bar-wrap">
                    <span
                      className="extra-color-gradient-2"
                      data-width={
                        statuses.AssessComplete != null
                          ? statuses.AssessComplete
                          : 0
                      }
                    >
                      <strong>
                        <i>
                          {statuses.AssessComplete != null
                            ? statuses.AssessComplete
                            : 0}
                        </i>
                        %
                      </strong>
                    </span>
                  </div>
                </div>
                <div className="nectar-progress-bar">
                  <p>ENGAGE // Goal: 10</p>
                  <div className="bar-wrap">
                    <span
                      className="extra-color-gradient-2"
                      data-width={
                        statuses.EngageComplete != null
                          ? statuses.EngageComplete
                          : 0
                      }
                    >
                      <strong>
                        <i>
                          {statuses.EngageComplete != null
                            ? statuses.EngageComplete
                            : 0}
                        </i>
                        %
                      </strong>
                    </span>
                  </div>
                </div>
                <div className="nectar-progress-bar">
                  <p>MAINTAIN // Goal: 10</p>
                  <div className="bar-wrap">
                    <span
                      className="extra-color-gradient-2"
                      data-width={
                        statuses.MaintainComplete != null
                          ? statuses.MaintainComplete
                          : 0
                      }
                    >
                      <strong>
                        <i>
                          {statuses.MaintainComplete != null
                            ? statuses.MaintainComplete
                            : 0}
                        </i>
                        %
                      </strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="vc_col-sm-6 wpb_column column_container vc_column_container col padding-1-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkingPage;
